import { Component, OnInit } from '@angular/core';
import { ChurchService } from '../../../services/church/church.service';
import { Church } from '../../../models/church.model';
import { MatDialog } from '@angular/material';
import { AlertComponent } from '../../../components/alert/alert.component';
import { Router } from '@angular/router';
import { isEmpty } from 'rxjs/operator/isEmpty';

@Component({
    selector: 'app-cargar-iglesias-csv',
    templateUrl: './cargar-iglesias-csv.component.html',
    styleUrls: ['./cargar-iglesias-csv.component.scss']
})
export class CargarIglesiasCsvComponent implements OnInit {

    file: File = null;

    iglesias: Church[] = [];
    subiendo: boolean = false;
    successMessage: boolean = false;
    errorMessage: boolean = false;

    constructor(private iglesiasService: ChurchService,
        private dialog: MatDialog,
        private router: Router) { }

    ngOnInit() {
    }

    leerArchivo(data: any) {

        // EN ESTE METODO AL SELECCIONAR UN ARCHIVO CSV, ES LEÍDO Y CONVERTIDO EN UN ARRAY PARA ASÍ ENVIARLO AL SERVIDOR

        this.file = data;

        let reader: FileReader = new FileReader();
        //reader.readAsText(this.file);
        reader.readAsText(this.file, 'ISO-8859-1');
        reader.onload = (e) => {
            let csv: any = reader.result;

            let iglesiasCSV = csv.split("\n");

            let headers: string[] = iglesiasCSV[0].split(";"); // Lee cabeceras de las church

            for (let i = 0; i < headers.length; i++) {
                headers[i] = headers[i].toLowerCase().trim();
            }

            for (let i = 1; i < iglesiasCSV.length; i++) {

                let iglesiaArray = iglesiasCSV[i].split(";");

                let iglesia: any = {};

                if (iglesiaArray.length == headers.length) {
                    for (let z = 0; z < headers.length; z++) {

                        iglesia[headers[z].trim()] = iglesiaArray[z].trim();
                    }

                    this.iglesias.push(iglesia);
                }

            }
        }

        console.log(this.iglesias);

    }


    cargarIglesias() {
        this.subiendo = true;
        this.successMessage = false;
        this.errorMessage = false;

        //console.log(this.iglesias);

        this.iglesiasService.uploadCSV(this.iglesias)
            .subscribe((data) => {
                this.subiendo = false;

                this.dialog.open(AlertComponent, {
                    width: '35vw',
                    disableClose: true,
                    data: {
                        title: 'Felicitaciones',
                        content: "Las iglesias fueron subidas correctamente"
                    }
                })

                this.router.navigate(['/', 'admin', 'iglesias']);
            }, (error) => {
                console.log(error);
                this.subiendo = false;

                this.dialog.open(AlertComponent, {
                    width: '35vw',
                    disableClose: true,
                    data: {
                        title: 'Lo sentimos',
                        content: "Hubo un problema al intentar subir las iglesias"
                    }
                })
            })
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/pages/cargar-iglesias-csv/cargar-iglesias-csv.component.ts